import React from 'react';

import IconArrow from '@components/Images/IconArrow';
import LogoTIProWithIconTI from '@components/Images/Rebranding/LogoTIProWithIconTI';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import LazyImgixImage from '@components/LazyImgixImage';
import { useEventTracking } from '@hooks';
import { ClickTarget, click } from '@tracking';
import { getImgixSrc } from '@utils/images';

import DeepResearchPromo from './DeepResearchPromo';
import ProUpgradePromo from './ProUpgradePromo';

export interface MobileContentProps {
  isProSubscriber: boolean;
}

const MobileContent = ({ isProSubscriber }: MobileContentProps) => {
  const { trackEvent } = useEventTracking();
  return (
    <div className="flex w-full flex-col md:hidden">
      <div className="flex flex-col justify-start px-32">
        {isProSubscriber ? (
          <LogoTIProWithIconTI className="h-[40px] w-[200px]" />
        ) : (
          <LogoTIWithIconTI className="h-[40px] w-[200px]" />
        )}
        <div>
          <h3 className="text-headline-xx m-0 mb-8 mt-48 font-suisse-screen font-bold">
            You&apos;re All Set!
          </h3>
          <p className="m-0 mb-24 font-suisse-screen text-byline-md">
            Check your inbox from The Information and enjoy reading the best in tech news.
          </p>
        </div>
        {isProSubscriber ? (
          <DeepResearchPromo
            isMobile
            className="w-full bg-grayscale-beige p-20 [clip-path:polygon(0_0,100%_0,100%_calc(100%-3rem),calc(100%-5rem)_100%,0_100%)]"
          />
        ) : (
          <ProUpgradePromo isMobile />
        )}
      </div>
      <a
        className="absolute bottom-0 flex w-full items-center justify-center gap-8 bg-grayscale-charcoal py-20"
        href="https://theinformation.onelink.me/6IaG/3stnun15"
        data-testid="download-app"
        onClickCapture={() => {
          trackEvent(click({ clickTarget: ClickTarget.DownloadApp }));
        }}
      >
        <LazyImgixImage
          src={getImgixSrc({
            path: '/onboarding/app_icon.png',
            isEnvDependent: false,
          })}
          alt="App Logo"
          className="w-full"
          wrapperClassName="!flex w-[40px]"
        />
        <div className="font-suisse-intl font-medium text-white">Download the App</div>
        <IconArrow className="relative ml-12 h-[15px] rotate-180 text-primary-magenta" />
      </a>
    </div>
  );
};

export default MobileContent;
